import { useContext } from 'react';
import { type ToggleButtonContextValue, ToggleContext } from './context';

/**
 * Hook to access the toggle context.
 */
export const useToggleButtonContext = (): ToggleButtonContextValue =>
  useContext(ToggleContext);
